module.exports = __webpack_public_path__ + "img/05-cafe-bar-morgal.c130706d.jpg";